export default __webpack_public_path__ + "static/media/ORBIT-LOGO-KOWHITE.90a683c5.svg";